import { cn } from "@/lib/utils";
import { Loader2Icon } from "lucide-react";
import React from "react";

const LoadingText = ({
	text,
	classNames,
}: {
	text?: string;
	classNames?: { container?: string; loader?: string; text?: string };
}) => {
	return (
		<div className={cn("flex items-center justify-start gap-1", classNames?.container)}>
			<Loader2Icon
				className={cn("h-5 w-5 animate-spin stroke-brand-primary", classNames?.loader)}
			/>

			<span className={cn("text-sm text-gray-600", classNames?.text)}>{text}</span>
		</div>
	);
};

export default LoadingText;
